import { toastService } from "src/libraries/toast";
import { getNewsCategoriesUseCase } from "./getNewsCategoriesUseCase";
import { appStateModel } from "src/entities/appState/AppStateModel";
import { newsCategoryService } from "../entity/newsCategories/NewsCategoryService";

export const deleteNewsCategoryUseCase = async (id: number) => {
    try {
        appStateModel.isLoading = true;
        const response = await newsCategoryService.delete(id);
        if (response?.isError) {
            toastService.onError('Some error');
        } else {
            await getNewsCategoriesUseCase();
            toastService.onSuccess('Success');
        }
    } catch (error) {
        console.warn('deleteNewsCategoryUseCase: ', error);
    } finally {
        appStateModel.isLoading = false;
    }
}   